import { SimulatorTabProps } from '../../../../common/simulator/simulator.models';
import dayImage from '../../../../../assets/images/simulator/day-no-blur.jpg';
import dayImageTablet from '../../../../../assets/images/simulator/day-no-blur-tablet.jpg';
import dayImageDesktop from '../../../../../assets/images/simulator/day-no-blur-desktop.jpg';
import dayImageDesktopBlur from '../../../../../assets/images/simulator/blur-desktop.jpg';
import dayImageTabletBlur from '../../../../../assets/images/simulator/day-blur-tablet.jpg';
import dayImageBlur from '../../../../../assets/images/simulator/day-blur.jpg';
import gadgetsImage from '../../../../../assets/images/simulator/gadgets-no-blur.jpg';
import gadgetsImageTablet from '../../../../../assets/images/simulator/gadgets-no-blur-tablet.jpg';
import gadgetsImageDesktop from '../../../../../assets/images/simulator/gadgets-no-blur-desktop.jpg';
import gadgetsImageDesktopBlur from '../../../../../assets/images/simulator/gadgets-blur-desktop.jpg';
import gadgetsImageTabletBlur from '../../../../../assets/images/simulator/gadgets-blur-tablet.jpg';
import gadgetsImageBlur from '../../../../../assets/images/simulator/gadgets-blur.jpg';
import nightImage from '../../../../../assets/images/simulator/night-no-blur.jpg';
import nightImageTablet from '../../../../../assets/images/simulator/night-no-blur-tablet.jpg';
import nightImageDesktop from '../../../../../assets/images/simulator/night-no-blur-desktop.jpg';
import nightImageDesktopBlur from '../../../../../assets/images/simulator/night-blur-desktop.jpg';
import nightImageTabletBlur from '../../../../../assets/images/simulator/night-blur-tablet.jpg';
import nightImageBlur from '../../../../../assets/images/simulator/night-blur.jpg';

export const tabs: SimulatorTabProps[] = [
  {
    name: 'simulator.day',
    benefits: [
      { content: 'simulator.aom1d.day.benefit-1', arrowPosition: 'top-left', position: { x: 55, y: 30 } },
      { content: 'simulator.aom1d.day.benefit-2', arrowPosition: 'top-left', position: { x: 50, y: 62 } },
      { content: 'simulator.aom1d.day.benefit-3', arrowPosition: 'bottom-right', position: { x: 10, y: 45 } },
      { content: 'simulator.aom1d.day.benefit-4', arrowPosition: 'top-left', position: { x: 27, y: 70 } },
    ],
    background: dayImage,
    backgroundBlur: dayImageBlur,
  },
  {
    name: 'simulator.gadgets',
    benefits: [
      { content: 'simulator.aom1d.gadgets.benefit-1', arrowPosition: 'top-left', position: { x: 26, y: 51 } },
      { content: 'simulator.aom1d.gadgets.benefit-2', arrowPosition: 'top-left', position: { x: 47, y: 25 } },
      { content: 'simulator.aom1d.gadgets.benefit-3', arrowPosition: 'top-left', position: { x: 36, y: 35 } },
      { content: 'simulator.aom1d.gadgets.benefit-4', arrowPosition: 'top-right', position: { x: 48, y: 68 } },
    ],
    background: gadgetsImage,
    backgroundBlur: gadgetsImageBlur,
  },
  {
    name: 'simulator.night',
    benefits: [
      { content: 'simulator.aom1d.night.benefit-1', arrowPosition: 'top-left', position: { x: 52, y: 27.7 } },
      { content: 'simulator.aom1d.night.benefit-2', arrowPosition: 'bottom-right', position: { x: 9, y: 71 } },
      { content: 'simulator.aom1d.night.benefit-3', arrowPosition: 'bottom-left', position: { x: 43, y: 44 } },
      { content: 'simulator.aom1d.night.benefit-4', arrowPosition: 'bottom-left', position: { x: 51, y: 60 } },
    ],
    background: nightImage,
    backgroundBlur: nightImageBlur,
  },
];

export const tabsTablet: SimulatorTabProps[] = [
  {
    name: 'simulator.day',
    benefits: [
      { content: 'simulator.aom1d.day.benefit-1', arrowPosition: 'top-left', position: { x: 42.4, y: 23 } },
      { content: 'simulator.aom1d.day.benefit-2', arrowPosition: 'top-left', position: { x: 37, y: 39 } },
      { content: 'simulator.aom1d.day.benefit-3', arrowPosition: 'bottom-right', position: { x: 34, y: 51 } },
      { content: 'simulator.aom1d.day.benefit-4', arrowPosition: 'top-left', position: { x: 38, y: 73 } },
    ],
    background: dayImageTablet,
    backgroundBlur: dayImageTabletBlur,
  },
  {
    name: 'simulator.gadgets',
    benefits: [
      { content: 'simulator.aom1d.gadgets.benefit-1', arrowPosition: 'top-left', position: { x: 40, y: 45 } },
      { content: 'simulator.aom1d.gadgets.benefit-2', arrowPosition: 'top-left', position: { x: 50, y: 20 } },
      { content: 'simulator.aom1d.gadgets.benefit-3', arrowPosition: 'top-left', position: { x: 45, y: 29 } },
      { content: 'simulator.aom1d.gadgets.benefit-4', arrowPosition: 'top-right', position: { x: 49, y: 60 } },
    ],
    background: gadgetsImageTablet,
    backgroundBlur: gadgetsImageTabletBlur,
  },
  {
    name: 'simulator.night',
    benefits: [
      { content: 'simulator.aom1d.night.benefit-1', arrowPosition: 'top-left', position: { x: 36, y: 21 } },
      { content: 'simulator.aom1d.night.benefit-2', arrowPosition: 'bottom-left', position: { x: 40, y: 58 } },
      { content: 'simulator.aom1d.night.benefit-3', arrowPosition: 'bottom-left', position: { x: 46, y: 42 } },
      { content: 'simulator.aom1d.night.benefit-4', arrowPosition: 'top-left', position: { x: 52, y: 72 } },
    ],
    background: nightImageTablet,
    backgroundBlur: nightImageTabletBlur,
  },
];

export const tabsDesktop: SimulatorTabProps[] = [
  {
    name: 'simulator.day',
    benefits: [
      { content: 'simulator.aom1d.day.benefit-1', arrowPosition: 'top-right', position: { x: 36, y: 47 } },
      { content: 'simulator.aom1d.day.benefit-2', arrowPosition: 'top-left', position: { x: 57, y: 73 } },
      { content: 'simulator.aom1d.day.benefit-3', arrowPosition: 'bottom-left', position: { x: 55, y: 25 } },
      { content: 'simulator.aom1d.day.benefit-4', arrowPosition: 'top-left', position: { x: 35, y: 73 } },
    ],
    background: dayImageDesktop,
    backgroundBlur: dayImageDesktopBlur,
  },
  {
    name: 'simulator.gadgets',
    benefits: [
      { content: 'simulator.aom1d.gadgets.benefit-1', arrowPosition: 'top-right', position: { x: 29, y: 53 } },
      { content: 'simulator.aom1d.gadgets.benefit-2', arrowPosition: 'top-left', position: { x: 45, y: 76 } },
      { content: 'simulator.aom1d.gadgets.benefit-3', arrowPosition: 'top-left', position: { x: 44, y: 35 } },
      { content: 'simulator.aom1d.gadgets.benefit-4', arrowPosition: 'top-right', position: { x: 55, y: 54 } },
    ],
    background: gadgetsImageDesktop,
    backgroundBlur: gadgetsImageDesktopBlur,
  },
  {
    name: 'simulator.night',
    benefits: [
      { content: 'simulator.aom1d.night.benefit-1', arrowPosition: 'top-left', position: { x: 50, y: 21 } },
      { content: 'simulator.aom1d.night.benefit-2', arrowPosition: 'bottom-left', position: { x: 54, y: 47 } },
      { content: 'simulator.aom1d.night.benefit-3', arrowPosition: 'top-right', position: { x: 33, y: 42 } },
      { content: 'simulator.aom1d.night.benefit-4', arrowPosition: 'top-left', position: { x: 42, y: 72 } },
    ],
    background: nightImageDesktop,
    backgroundBlur: nightImageDesktopBlur,
  },
];
